const Search = new function() {
    let searchButtons = [];
    let searchPanel = null;
    let closeButton = null;
    let searchInput = null;

    this.init = () => {
        searchPanel = document.querySelector('.ss-search');
        searchInput = searchPanel.querySelector('.ss-searchform__input');
        document.querySelectorAll('.ss-searcher').forEach(button => searchButtons.push(button));
        closeButton = searchPanel.querySelector('.ss-nav-button');

        searchButtons.forEach(button => button.addEventListener('click', this.open));
        closeButton.addEventListener('click', this.close)
    }

    this.open = (e) => {
        e.preventDefault();
        searchInput.value = '';
        searchPanel.classList.add('show');
    }
    
    this.close = (e) => {
        e.stopPropagation();
        e.preventDefault();
        searchPanel.classList.remove('show');
    }
}

export default Search